import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import TeamManagement from '../components/TeamManagement';
import PassKeyManager from '../components/PassKeyManager';
import RoleManagement from '../components/RoleManagement';
import DashboardLayout from '../components/DashboardLayout';
import { Shield, Users, Key } from 'lucide-react';

const UsersAndRoles = () => {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Page Header */}
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Team & Roles</h1>
          <p className="text-gray-500 mt-1">
            Manage team members, assign roles, and generate temporary access keys for collaborators
          </p>
        </div>

        {/* Tabs */}
        <Tabs defaultValue="team" className="w-full">
          <TabsList className="grid w-full grid-cols-3 mb-6">
            <TabsTrigger value="team" className="flex items-center gap-2">
              <Users className="h-4 w-4" />
              Team
            </TabsTrigger>
            <TabsTrigger value="roles" className="flex items-center gap-2">
              <Shield className="h-4 w-4" />
              Roles
            </TabsTrigger>
            <TabsTrigger value="passkeys" className="flex items-center gap-2">
              <Key className="h-4 w-4" />
              Pass Keys
            </TabsTrigger>
          </TabsList>

          <TabsContent value="team">
            <TeamManagement />
          </TabsContent>

          <TabsContent value="roles">
            <RoleManagement />
          </TabsContent>

          <TabsContent value="passkeys">
            <PassKeyManager />
          </TabsContent>
        </Tabs>
      </div>
    </DashboardLayout>
  );
};

export default UsersAndRoles;
